import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import {
  CarouselRoot,
  CarouselControls,
  CarouselState,
  CarouselPreviousButton,
  CarouselNextButton,
  UnstyledCarouselScrollArea,
  Flex,
  Box,
} from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { useFindLocaleText } from '../../text-localisation'
import { useSearchStore } from '../../store/SearchStore'
import { createCarouselFilterItems } from './createCarouselFilterItems'
import { useNbaFilters } from '../../utils/nbaFilters'
import { IntegerFilter } from '../../services/types/services'

const StyledFlex = styled(Flex)`
  ${s({
    width: { xs: '100vw', md: '100%' },
    maxWidth: '1200px',
    marginX: 'auto',
    flexDirection: 'column',
    py: { xs: 3, md: 4 },
    mb: 0,
    pr: { md: 6, xl: 0 },
    pl: { xs: 6, xl: 0 },
  })}
`

const StyledCarouselRoot = styled(CarouselRoot)`
  ${s({
    px: 0,
  })}
`

const StyledCarouselScrollArea = styled(UnstyledCarouselScrollArea)`
  gap: ${spacingPx(4)};
`

export const FiltersCarousel: FC = () => {
  const localiseText = useFindLocaleText()

  const filtersfromStore = useSearchStore(store => store.filters) || []
  const filters = useNbaFilters(filtersfromStore)
  const resultsLoading = useSearchStore(store => store.loading)
  const selectedFilters = useSearchStore(store => store.selectedFilters)
  const optimisticRender = useSearchStore(store => store.optimisticRender)
  const integerFilters = useSearchStore(store => store.integerFilters)

  const appliedIntegerFilters = filtersfromStore.filter(
    f =>
      f.__typename === 'IntegerFilter' &&
      integerFilters.some(
        integerFilter => integerFilter.integerId === f.integerId,
      ) &&
      f.selectedValue !== null,
  ) as IntegerFilter[]

  const carouselItems = createCarouselFilterItems({
    filters,
    resultsLoading,
    selectedFilters: [...selectedFilters, ...appliedIntegerFilters],
    optimisticRender,
    localiseText,
  })

  return (
    <StyledFlex data-testid="filters-carousel">
      {carouselItems.length > 0 ? (
        <CarouselState>
          <StyledCarouselRoot aria-label={localiseText('find.nba_filters')}>
            <Box display={{ xs: 'none', md: 'block' }}>
              <CarouselControls>
                <CarouselPreviousButton />
                <CarouselNextButton />
              </CarouselControls>
            </Box>
            <StyledCarouselScrollArea>{carouselItems}</StyledCarouselScrollArea>
          </StyledCarouselRoot>
        </CarouselState>
      ) : /* istanbul ignore next */ null}
    </StyledFlex>
  )
}
